import {ChangeDetectionStrategy, Component, inject, signal, WritableSignal} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {APP_MODAL_REF} from '../../../constants/modal/app-modal-ref.constant';
import {AppButtonTypeEnum} from '../../../enums/button/app-button-type.enum';
import {ButtonColorEnum} from '../../../enums/button/button-color.enum';
import {AppDialogModal} from '../../../models/modal/dialog/app-dialog-modal.model';
import {ModalService} from '../../../services/modal/modal.service';
import {AppConnectionLostDialogData} from '../../../types/modal/dialog/app-connection-lost-dialog-data.type';
import {ButtonComponent} from '../../buttons/button/button.component';

@Component({
    selector: 'app-connection-lost-dialog',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        TranslatePipe
    ],
    templateUrl: './connection-lost-dialog.component.html',
    styleUrl: './connection-lost-dialog.component.css',
})
export class ConnectionLostDialogComponent {
    public readonly modalData: AppConnectionLostDialogData;
    protected readonly qaTag: string;
    protected readonly isChecking: WritableSignal<boolean>;
    protected readonly hasRetryFailed: WritableSignal<boolean>;
    protected readonly AppButtonTypeEnum = AppButtonTypeEnum;
    protected readonly ButtonColorEnum = ButtonColorEnum;
    private readonly modalRef = inject<AppDialogModal<ConnectionLostDialogComponent, AppConnectionLostDialogData, boolean>>(APP_MODAL_REF);
    private readonly modalService = inject(ModalService);

    public constructor() {
        this.qaTag = this.modalRef.qaTag;
        this.modalData = this.modalRef.modalData;
        this.isChecking = signal(false);
        this.hasRetryFailed = signal(false);
    }

    protected async checkConnection(): Promise<void> {
        if (this.isChecking()) {
            return;
        }

        this.isChecking.set(true);
        try {
            const reconnected = await this.modalData.connectionCheck();
            if (reconnected) {
                this.modalService.closeModal(this.modalRef, true);
                return;
            }
        } catch {
            // Fall through to the inline failure state below.
        }

        this.hasRetryFailed.set(true);
        this.isChecking.set(false);
    }

    protected closeModal(): void {
        if (this.isChecking()) {
            return;
        }
        this.modalService.closeModal(this.modalRef, false);
    }
}
